import { getIn, formatAmounts } from '@aytm/app/stats/lib/util/helpers'
import { processText } from '@aytm/app/stats/page/components/lib/utils'
import { getImage } from '@aytm/app/stats/lib/stat-page'

// Builds the quadrant items-list Table props (Entities title col + one value col per `table`
// entry). Ported from info_view/charts/quadrant.coffee QuadrantItemsListView#calcItemsListProps.
// The legacy meanList/scoreList sort block was dead code (its guard locals were never defined).
export const calcItemsListProps = ({ id, table, answer, questionVariants, chartLegendMode }) => {
  const isLoading = 'loading' === answer

  const answerVariants = questionVariants.map(qv => {
    const av = {
      text: `${qv.position}. ${processText(qv.text)}${'long' !== chartLegendMode ? ` (E${qv.position})` : ''}`,
      position: qv.position
    }
    if (Object.hasOwn(qv, 'image')) {
      av.image = getImage(qv.image)
    }
    return av
  })

  const cols = [{ type: 'title', title: '' }].concat(
    table.map(item => ({
      type: 'value',
      title: item.title || '&nbsp;',
      width: `${60 / table.length}%`,
      format: value => (Number.isFinite(value) && formatAmounts(value)) || value
    }))
  )

  const rows = answerVariants.map(av => {
    const row = {
      cells: [{ title: av.text, colorIndex: ((av.position - 1) % 21) + 1 }].concat(
        table.map(item => {
          const as = getIn(item.path, answer, { $key: av.position })
          const ass = getIn(item.cellStylePath, answer, { $key: av.position }) || []
          return {
            value: (as !== undefined && as) || '-',
            loading: isLoading,
            classNames: (Array.isArray(ass) && ass) || [ass]
          }
        })
      ),
      position: av.position
    }

    if (Object.hasOwn(av, 'image')) {
      row.cells[0].image = av.image
    }

    return row
  })

  return { id, cols, rows }
}
